import ApiClient from './ApiClient';

class FlowDefinitionsAPI extends ApiClient {
  constructor() {
    super('flow_definitions', { accountScoped: true });
  }
}

export default new FlowDefinitionsAPI();
